// extracted by mini-css-extract-plugin
export default {"TopButton":"scrollbutton_TopButton__XFbev"};